export const BUSINESS = {
  name: "KAZIM'S",
  brandMessage: {
    en: "Kazims. Where tea is more than a drink — it's an experience.",
    hi: "Kazims — जहाँ चाय केवल पेय नहीं, एक अनुभव है।",
  },
  phoneDisplay: "6306859310",
  tel: "tel:+916306859310",
  whatsapp: "https://wa.me/916306859310",
  whatsappEnquiry: (text) =>
    `https://wa.me/916306859310?text=${encodeURIComponent(text)}`,
  email: "kazims5050@gmail.com",
  mailto: "mailto:kazims5050@gmail.com",
  instagram: "https://www.instagram.com/kazims50",
  instagramHandle: "@KAZIMS50",
  addressLines: {
    en: [
      "Bhatakua Patti, Daya Rai, Near BTI Masjid,",
      "Imamganj, Mau,",
      "Uttar Pradesh - 275101, India",
    ],
    hi: [
      "भटकुआ पट्टी, दया राय, बीटीआई मस्जिद के पास,",
      "इमामगंज, मऊ,",
      "उत्तर प्रदेश - 275101, भारत",
    ],
  },
  founded: { en: "1 September 2026", hi: "1 सितंबर 2026" },
  mapEmbed:
    "https://www.google.com/maps?q=Imamganj%2C%20Mau%2C%20Uttar%20Pradesh%20275101%2C%20India&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Imamganj+Mau+Uttar+Pradesh+275101+India",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1663597675745-96a3f784369e?crop=entropy&cs=srgb&fm=jpg&q=85",
  intro: "https://images.pexels.com/photos/38237927/pexels-photo-38237927.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  product: "https://images.unsplash.com/photo-1787167653518-11092672b2f4?crop=entropy&cs=srgb&fm=jpg&q=85",
  productAlt: "https://images.unsplash.com/photo-1672846785798-a8e82326abab?crop=entropy&cs=srgb&fm=jpg&q=85",
  about: "https://images.pexels.com/photos/38093054/pexels-photo-38093054.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  strainer: "https://images.unsplash.com/photo-1582466226476-e15c1db298f3?crop=entropy&cs=srgb&fm=jpg&q=85",
  darkCup: "https://images.pexels.com/photos/6064681/pexels-photo-6064681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const REGIONS = [
  {
    id: "siliguri",
    name: "Siliguri",
    image:
      "https://images.unsplash.com/photo-1658051161493-1d311c4c7b4d?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: {
      en: "The gateway to North Bengal's tea country — our blend draws its crisp, full-bodied base from this region.",
      hi: "उत्तर बंगाल के चाय इलाकों का प्रवेश द्वार — इसी क्षेत्र से आता है हमारे मिश्रण का ठोस, भरपूर आधार।",
    },
  },
  {
    id: "new-jalpaiguri",
    name: "New Jalpaiguri",
    image:
      "https://images.unsplash.com/photo-1758390286386-87c9d78cf9be?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: {
      en: "From the foothill belt around NJP — teas that lend a vibrant amber depth to the cup.",
      hi: "न्यू जलपाईगुड़ी की तराई पट्टी से — कप में गहरा, शानदार रंग भरने वाली चाय।",
    },
  },
  {
    id: "darjeeling",
    name: "Darjeeling",
    image:
      "https://images.pexels.com/photos/35491392/pexels-photo-35491392.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: {
      en: "The hills that need no introduction — delicate, floral notes give our blend its lift.",
      hi: "दार्जीलिंग की पहाड़ियाँ — नाज़ुक, फूलों जैसी सुगंध हमारे मिश्रण को ऊँचाई देती है।",
    },
  },
  {
    id: "guwahati",
    name: "Guwahati",
    image:
      "https://images.pexels.com/photos/3848200/pexels-photo-3848200.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: {
      en: "Assam's tea heartland near Guwahati — the source of our blend's strength and malty richness.",
      hi: "गुवाहाटी के पास असम का चाय दिल — यहीं से आती है हमारे मिश्रण की ताकत और गहरी माल्टी सुगंध।",
    },
  },
];

export const PRODUCTS = [
  {
    id: "kazims-flavor-fusion-tea",
    slug: "kazims-flavor-fusion-tea",
    name: "Kazims Flavor Fusion Tea",
    size: "1 KG",
    price: 360,
    currency: "₹",
    image: IMAGES.product,
    imageAlt: IMAGES.productAlt,
    origin: "Siliguri · New Jalpaiguri · Darjeeling · Guwahati",
    category: { en: "Premium Leaf Tea", hi: "प्रीमियम पत्ती चाय" },
    description: {
      en: "Experience the art of blending with Kazims Flavor Fusion Tea — a carefully crafted premium leaf tea that brings together teas from the hills of Siliguri, New Jalpaiguri, Darjeeling, and Guwahati.\n\nEach leaf is selected for its purity, aroma, and character. Our unique fusion creates a smooth, layered cup that is rich in flavour yet light on the palate — perfect for those who appreciate refined taste.",
      hi: "काज़िम्स फ्लेवर फ्यूज़न टी के साथ ब्लेंडिंग का कौशल महसूस करें — यह प्रीमियम पत्ती चाय सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी की पहाड़ियों से आई चायों को सधे हुए अंदाज़ में मिलाकर तैयार की गई है।\n\nहर पत्ती को उसकी शुद्धता, सुगंध और अपनेपन के लिए चुना गया है। हमारा ख़ास फ्यूज़न एक स्मूद, परतों भरा कप बनाता है — स्वाद में गहरा, पर फिर भी हल्का — जो बारीक स्वाद पसंद करने वालों के लिए बना है।",
    },
    highlights: [
      { en: "Premium whole leaf tea", hi: "प्रीमियम साबुत पत्ती की चाय" },
      { en: "Sourced from renowned tea regions", hi: "प्रसिद्ध चाय क्षेत्रों से सोर्स की गई" },
      { en: "Smooth, well-balanced flavour", hi: "स्मूद, संतुलित स्वाद" },
      { en: "Pure & carefully selected", hi: "शुद्ध और बारीकी से चुनी गई" },
    ],
  },
];
